import { isTrue, type TeamData, type TeamId } from '@terros/common'
import { getAncestorTeams, toTeamRelations, type TeamRelations } from './sortTeams'

export const toVisibilityBoundaries = (teams: TeamData[]): Map<TeamId, TeamData> => {
  const relations = toTeamRelations(teams)
  const boundaries = new Map<TeamId, TeamData>()

  for (const team of teams) {
    const boundary = findVisibilityBoundary(team, relations)
    if (boundary) boundaries.set(team.teamId, boundary)
  }

  return boundaries
}

const findVisibilityBoundary = (team: TeamData, relations: TeamRelations<TeamData>): TeamData | undefined => {
  if (isTrue(team.restrictVisibility)) return team
  return getAncestorTeams(team, relations).findLast((ancestor) => isTrue(ancestor.restrictVisibility))
}
